<div class="app-container" [class.rtl]="isRtl()">
      <!-- Global Loading Spinner -->
      <app-loading-spinner
        *ngIf="loadingService.isLoading()"
        [message]="'جاري التحميل...'">
      </app-loading-spinner>

      <!-- Main Router Outlet -->
      <router-outlet></router-outlet>

      <!-- PWA Update Available -->
      <div class="pwa-update" *ngIf="showPwaPrompt()"
           (click)="updatePwa()">
        <i class="material-icons">system_update</i>
        تحديث متاح - اضغط للتحديث
      </div>
    </div>
